import HTMLFlipBook from "react-pageflip";
import { useEffect, useRef, useState } from "react";
import useWindowWide from "../../userwidth";
import "../../styles.scss";
import axios from 'axios'
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import Magnify from "../../components/Magnify";
import Back from "../../components/Back";
import Menu from "../../components/Menu";
import Prev from "../../components/Prev";
import Next from "../../components/Next";
import {
    Magnifier,
    GlassMagnifier,
    SideBySideMagnifier,
    PictureInPictureMagnifier,
    MOUSE_ACTIVATION,
    TOUCH_ACTIVATION
} from "react-image-magnifiers";
import {useLocation, useParams} from 'react-router-dom'
import Pause from "../../components/Pause";
import MagnifyOff from '../../components/MagnifyOff';
import Play from "../../components/Play";


const ListOfPages = (props) => {
    return (
        <div className="fullscreen" style={{backgroundColor: '#000000ed', zIndex: 20000}}>
            <CloseButton togglePlayer={props.close} />
            <div className=" mt-14 mb-14" style={{marginInline: 275,  overflowY: 'scroll', backgroundColor: '#FFFFFF', height: '90%'}}>
                <div className="row align-center mb-8 pl-3" style={{backgroundColor: '#D9D9D9', height: 60}}>
                    <span>Просмотр страниц</span>
                </div>
                <div className="pl-10 pr-10">
                    {props.items.map((page, idx)=>(
                        <img onClick={()=>{console.log(idx); props.pageSelected(idx)}} className="mb-8 mr-8" width={80} height={120} src={page} />
                    ))}
                </div>
            </div>
        </div>
    )
}

const TopBar = (props) => {
    return (
        <div className="row width-full  mt-4 align-center" style={{zIndex: 0, position: 'relative', alignContent: 'center'}}>
                <Back style={{position: 'absolute', left: 0}} onClick={()=>{}} />
                <span style={{fontSize:  28, textAlign: 'center', width: '100%'}} className='ml-4 regular-text-700 text__white'>{props.title}</span>
        </div>
    )
}

const BottomBar = (props) => {
    return (
        <div className="row width-full justify-space-between mt-4 align-center" style={{zIndex: 999}}>

                {!props.magnifyed && (
                    <div className="pointer" onClick={props.content}> <Menu /></div>
                )}
                {props.showMagnify && (
                    <div className='mr-4 pointer' onClick={props.toggleMagnify}><Magnify color={props.magnifyed ? '#EAC286' : '#66A3DB'}/></div>
                )}

        </div>
    )
}

const PlayButton = () =>{
    return (
        <svg style={{transform: 'scale(1.2)'}} width="40" height="40" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M67 35C67 42.9565 63.8393 50.5871 58.2132 56.2132C52.5871 61.8393 44.9565 65 37 65C29.0435 65 21.4129 61.8393 15.7868 56.2132C10.1607 50.5871 7 42.9565 7 35C7 27.0435 10.1607 19.4129 15.7868 13.7868C21.4129 8.16071 29.0435 5 37 5C44.9565 5 52.5871 8.16071 58.2132 13.7868C63.8393 19.4129 67 27.0435 67 35ZM32.4625 24.0987C32.1821 23.8991 31.8522 23.7805 31.509 23.7559C31.1657 23.7314 30.8222 23.8017 30.5163 23.9594C30.2103 24.117 29.9537 24.3558 29.7744 24.6496C29.5951 24.9434 29.5002 25.2808 29.5 25.625V44.375C29.5002 44.7192 29.5951 45.0566 29.7744 45.3504C29.9537 45.6442 30.2103 45.883 30.5163 46.0406C30.8222 46.1983 31.1657 46.2686 31.509 46.2441C31.8522 46.2195 32.1821 46.1009 32.4625 45.9012L45.5875 36.5262C45.8306 36.3528 46.0287 36.1238 46.1654 35.8583C46.3021 35.5929 46.3734 35.2986 46.3734 35C46.3734 34.7014 46.3021 34.4071 46.1654 34.1417C46.0287 33.8762 45.8306 33.6472 45.5875 33.4737L32.4625 24.0987Z" fill="url(#paint0_linear_53_86)"/>
            <g >
            </g>
            <defs>
                <linearGradient id="paint0_linear_53_86" x1="37" y1="26.5" x2="37" y2="56.5" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#86BAEA"/>
                    <stop offset="0.26124" stopColor="#66A3DB"/>
                    <stop offset="0.346248" stopColor="#498ECE"/>
                    <stop offset="1" stopColor="#72B5F3"/>
                </linearGradient>
            </defs>
        </svg>

    )
}

const CloseButton = (props) => {
    return (
        <div onClick={props.togglePlayer} className='pointer' style={{position: 'absolute', top: '5%', right: '5%', zIndex: 99999}}>
            <svg width="31" height="28" viewBox="0 0 31 28" fill="none" xmlns="http://www.w3.org/2000/svg" >
                <path d="M18.68 13.64L30.6 28H23.8L15.28 17.76L6.8 28H0L11.88 13.64L0.6 -1.90735e-06H7.4L15.28 9.56L23.2 -1.90735e-06H30L18.68 13.64Z" fill="white"/>
            </svg>
        </div>

    )
}

const VideoPlayer = (props) => {
    const [hidden, setHidden] = useState('')

    function playVideo() {
        let v = document.getElementById('video')
        v.play()
        setHidden('hidden')
    }

    return (
        <div style={{height: '100%', width: '100%'}} className={'column justify-center align-center'}>
            <video autoPlay controls id="video" class="video-js vjs-default-skin" width="1300" height="760" src={props.video}></video>
            {/*<img className={hidden} src={require('../../assets/play.png')} width={'48px'} height={'48px'} style={{position: 'absolute', cursor: 'pointer'}} onClick={playVideo}/>*/}
        </div>
    )
}

const FloatingLeftButtons = (props) => {

    const [visible, setVisible] = useState('hidden')

    function openPlayer () {
        props.togglePlayer(props.right)
    }



    useEffect(()=>{
        console.log('FloatingLeftButtons ', props.right, props.children.hOffset, 100-(props.children.hOffset)/2);
        setTimeout(()=>{

            setVisible('')
            if (props.children.timeWhenHide && props.children.timeWhenHide>0) {
                setTimeout(()=>{
                    setVisible('hidden')
                }, props.children.timeWhenHide - props.children.timeWhenShow)
            }
            console.log('55', visible, props.children.timeWhenShow);
        }, props.children.timeWhenShow)
    }, [])

    return (
        <>
            {props.children.type==='audio' && (
                <img className={`${visible} slide-audio`} src={require('../../assets/newAudioIcon.png')} style={{position: 'absolute', top: `${700*props.children.yOffset/100}px`, left: `${props.width*props.children.hOffset/100}px`}}  width={props.audiosize} height={props.audiosize}/>
            )}
            {props.children.type==='video' && (
                <img  onClick={openPlayer} className={`${visible} slide-video`} src={require('../../assets/newVideoIcon.png')} style={{cursor: 'pointer', position: 'absolute', top: `${700*props.children.yOffset/100}px`, left: `${props.right>0 ? props.width+props.width*(props.children.hOffset/100) : props.width*(props.children.hOffset/100)}px`}}  width={props.videosize} height={props.videosize}/>
            )}
        </>
    )
}
const FloatingRightButtons = (props) => {

    const [visible, setVisible] = useState('hidden')

    function openPlayer () {
        props.togglePlayer(props.right)
    }

    useEffect(()=>{
        console.log('props.width*props.children.hOffset/100',props.width,props.children.hOffset ,props.width - props.width*props.children.hOffset/100)
        setVisible('hidden')
        console.log('right buttons', props.right, props.children.hOffset, 100-(props.children.hOffset)/2);
        setTimeout(()=>{
            setVisible('')
            if (props.children.timeWhenHide && parseInt(props.children.timeWhenHide)>0) {
                setTimeout(()=>{
                    setVisible('hidden')
                }, parseInt(props.children.timeWhenHide) - parseInt(props.children.timeWhenShow))
            }
            console.log('55', visible, parseInt(props.children.timeWhenShow));
        }, parseInt(props.children.timeWhenShow))
    }, [props])

    return (
        <>
            {props.children.type==='audio' && (
                <img
                    className={`${visible} slide-audio`}
                    width={props.audiosize}
                    height={props.audiosize}
                    src={require('../../assets/newAudioIcon.png')}
                    style={{position: 'absolute', top: `${700*props.children.yOffset/100}px`, right: `${(props.width - props.width*props.children.hOffset/100)-50}px`}} />
            )}
            {props.children.type==='video' && (
                <img
                    onClick={openPlayer}
                    width={props.videosize}
                    height={props.videosize}
                    className={`${visible}
                     slide-video`}
                    src={require('../../assets/newVideoIcon.png')}
                    style={{cursor: 'pointer', position: 'absolute', top: `${700*props.children.yOffset/100}px`, right: `${(props.width - props.width*props.children.hOffset/100)-100}px`}} />
            )}
        </>
    )
}


const Book = (props) => {
    const [bookData, setBookData] = useState({});

    const [audioUrls, setAudioUrls] = useState([]);

    const [width, setWidth] = useState(525);
    const [listOfImages, setListOfImages] = useState([]);
    const [height, setHeight] = useState(700);
    const widthScreen = useWindowWide();
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(0);
    const [videoPlayerShow, setVideoPlayerShow] = useState(false)
    const [showTableOfContent, setShowTableOfContent] = useState(false)
    const [magnifyerOn, setMagnifyerOn] = useState(false)
    const [list, setList] = useState(false)
    const [currentPlayProgress, setCurrentPlayProgress] = useState(0);
    const [currentBook, setCurrentBook] = useState({})
    const [currentPage, setCurrentPage] = useState('0')
    const [currentImageForMag, setCurrentImageForMag] = useState(null)

    const [currentVideo, setCurrentVideo] = useState('')
    const book = useRef();
    const params = useParams()

    useEffect(() => {
        if (
            bookData[page - 2] &&
            bookData[page - 2].audio &&
            bookData[page - 2].audio.length > 0
        ) {
        }
        setList(false)
    }, [page]);

    useEffect(() => {
        axios.get('http://kitap.alsu.tatar/api/tale/get/'+params.id).then((response)=>{
            setBookData(response.data.message)
            let r = response.data.message
            let arr = []
            Object.values(r.pages).forEach(page=>{
                if (page.image) {
                    arr.push('http://kitap.alsu.tatar'+page.image)
                }
            })
            setListOfImages(arr)
            let audio = null
            if (r.coverAudio) {
                 audio = new Audio('http://kitap.alsu.tatar'+r.coverAudio)
                audio.play()
            }
            return () => {audio.pause()}
        })

    }, []);

    useEffect(() => {
        console.log(currentImageForMag);
        console.log('=========currentImageForMag===========');

    }, [currentImageForMag]);



    function handlePageFlip(pageNumber) {
        console.log(pageNumber);
    }

    const updatePage = ({ data }) => {
        setCurrentPage(String(data))
        setCurrentImageForMag(null)

        if (data>0 && data<listOfImages.length-1  && bookData.pages[data].mag) {
            setCurrentImageForMag( bookData.pages[data].mag)
        }
        if (data>0 && data<listOfImages.length-1  && bookData.pages[data*1+1].mag ) {
            setCurrentImageForMag( bookData.pages[data*1+1].mag)
        }

        setPage(data + 2);
    };

    function togglePlayer (right) {
        console.log(currentPage)
        if (right>0) {
            setCurrentVideo('http://kitap.alsu.tatar'+bookData.pages[currentPage*1+1].video[0])
            console.log('http://kitap.alsu.tatar'+bookData.pages[currentPage*1+1].video[0])
        }
        if (right===0) {
            setCurrentVideo('http://kitap.alsu.tatar'+bookData.pages[currentPage].video[0])
            console.log('http://kitap.alsu.tatar'+bookData.pages[currentPage].video[0])
        }
        setVideoPlayerShow(videoPlayerShow=>!videoPlayerShow)
    }

    function toggleMagnify() {
        setMagnifyerOn(magnifyerOn=>!magnifyerOn)
    }

    function toggleShowContent() {
        setShowTableOfContent(showTableOfContent=>!showTableOfContent)
    }

    return (
        <>
            {bookData && bookData.pages && (
                <div className="flex" style={{ padding: "10px 0" }}>
                    <div className={"book-overlay"} />
                    {!magnifyerOn && !videoPlayerShow && currentPage>0 && (
                        <div onClick={() => {
                            setList(true)
                            book.current.pageFlip().flipPrev()
                        }} style={{display: 'flex', zIndex: 9, cursor: 'pointer'}}  className='mr-4' >
                            <Prev />
                        </div>)}
                    <div
                        className="column transformation-column"
                        style={{
                            position: "relative",
                            alignItems: "center",
                            justifyContent: 'flex-end',
                            width: height*1.5,
                            height: height+70,
                        }}
                    >
                        <TopBar content={toggleShowContent} magnifyed={magnifyerOn} toggleMagnify={toggleMagnify} showMagnify={currentImageForMag} title={bookData.title} />
                        {listOfImages.length>0 && (
                            <HTMLFlipBook
                                onFlip={updatePage}
                                width={width}
                                height={height}
                                ref={book}
                                style={magnifyerOn ? {display: 'none'} : {}}
                                showPageCorners={false}
                                showCover={true}
                            >
                                <div className="page">
                                    <img src={'http://kitap.alsu.tatar'+bookData.pages.titleCover} alt="person" />
                                </div>
                                {listOfImages.map((item, idx) => (
                                    <div className="page">
                                        <img src={listOfImages[idx]} alt="person" />
                                    </div>
                                ))}
                                <div className="page">
                                    <img src={'http://kitap.alsu.tatar'+bookData.pages.lastCover} alt="person" />
                                </div>
                            </HTMLFlipBook>
                        )}


                        {bookData.pages &&  bookData.pages[currentPage] && bookData.pages[currentPage].buttons && !list && (
                            <>
                                {bookData.pages[currentPage]?.buttons.map(buttonL=>(
                                    <FloatingLeftButtons audiosize={bookData.audioSize ? bookData.audioSize : 40} videosize={bookData.videoSize ? bookData.videoSize : 40} width={width} height={height} togglePlayer={togglePlayer} children = {buttonL} right={0}/>
                                ))}

                            </>
                        )}
                        {bookData.pages &&  bookData.pages[currentPage*1+1] && bookData.pages[currentPage*1+1].buttons && !list && currentPage>0 && (
                            <>
                                {bookData.pages[currentPage*1+1].buttons.map(buttonR=>(
                                    <>
                                        <FloatingRightButtons audiosize={bookData.audioSize ? bookData.audioSize : 40} videosize={bookData.videoSize ? bookData.videoSize : 40} width={width} height={height} togglePlayer={togglePlayer} children = {buttonR} right={1}/>
                                    </>
                                ))}

                            </>
                        )}
                        {bookData.pages && bookData.pages[currentPage] && bookData.pages[currentPage].audio && bookData.pages[currentPage].audio.length>0 && !videoPlayerShow && (
                            <div className="progress row" >
                                <AudioPlayer
                                    autoPlay
                                    src={'http://kitap.alsu.tatar'+bookData.pages[currentPage].audio[0]}
                                    onPlay={(e) => console.log("onPlay")}
                                    showDownloadProgress={false}
                                    showSkipControls={false}
                                    showCover={false}
                                    preload = 'none'
                                    customVolumeControls={[]}
                                    customAdditionalControls={[]}
                                    showJumpControls={false}
                                    defaultCurrentTime="" defaultDuration=""
                                    customIcons={{
                                        play: <Play />,
                                        pause: <Pause />
                                    }}
                                />
                            </div>
                        )}
                        {bookData.pages && currentPage!=='0' && bookData.pages[currentPage*1+1] && bookData.pages[currentPage*1+1].audio && bookData.pages[currentPage*1+1].audio.length>0 && !videoPlayerShow && (
                            <div className="progress row">
                                <AudioPlayer
                                    autoPlay
                                    src={'http://kitap.alsu.tatar'+bookData.pages[currentPage*1+1].audio[0]}
                                    onPlay={(e) => console.log("onPlay")}
                                    showDownloadProgress={false}
                                    showSkipControls={false}
                                    showCover={false}
                                    preload = 'none'
                                    customVolumeControls={[]}
                                    customAdditionalControls={[]}
                                    showJumpControls={false}
                                    defaultCurrentTime="" defaultDuration=""
                                    customIcons={{
                                        play: <Play />,
                                        pause: <Pause />
                                    }}
                                />
                            </div>
                        )}
                        {currentVideo && videoPlayerShow && (
                            <div style={{width: '100%', height: '100%', backgroundColor: '#222222ef',  position: 'fixed', top: 0, bottom: 0, right: 0, left: 0}}>
                                <CloseButton togglePlayer={togglePlayer} />
                                <VideoPlayer video={currentVideo} />
                            </div>
                        )}
                        {page>=0 && ! videoPlayerShow && (
                            <BottomBar content={toggleShowContent} magnifyed={magnifyerOn} toggleMagnify={toggleMagnify} showMagnify={currentImageForMag} title={bookData.title} />
                        )}
                    </div>
                    {!magnifyerOn && !videoPlayerShow &&(
                        <div onClick={() => {
                            setList(true)
                            book.current.pageFlip().flipNext()
                        }} style={{display: 'flex', zIndex: 9, cursor: 'pointer'}} className='ml-4'>
                            <Next />
                        </div>
                    )}
                    {showTableOfContent && (
                        <ListOfPages items={listOfImages} close={toggleShowContent} pageSelected={(page)=>{ book.current.pageFlip().turnToPage(page+1);  setShowTableOfContent(false)}}/>
                    )}
                    {magnifyerOn && currentImageForMag && (
                        <div className="row book-overlay" style={{paddingTop: 40, paddingBottom: 40, paddingLeft: '22%', paddingRight: '20%', width: '56%', zIndex: 99999, alignItems: 'center'}}>
                            <GlassMagnifier
                                style={{objectFit: 'contain',}}
                                imageSrc={'http://kitap.alsu.tatar'+currentImageForMag}
                                imageAlt="Example"
                                allowOverflow={true}
                                magnifierBorderColor={'#EAC286'}
                                magnifierBorderSize = {8}
                                magnifierSize={250}
                            />
                            {magnifyerOn && (
                                <div className='ml-4 pointer' onClick={toggleMagnify}><MagnifyOff color={magnifyerOn ? '#EAC286' : '#66A3DB'}/></div>
                            )}

                        </div>
                    )}
                </div>

            )}
        </>
    );
}

export default Book
